import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg组件
import 'virtual:svg-icons-register'

// register globally
Vue.component('svg-icon', SvgIcon)
